<template>
    <div>
      <form :id='formParams.formId' v-if="hackReset">
      <table width="100%">
        <template v-for="site in formParams.json._jsonShow">
          <tr>
            <td style="padding-bottom: 18px; padding-right: 100px" v-for="index in formParams.json._lineSize"  :colspan="site.length === 1 ? formParams.json._lineSize : 1">
              <ParseJson ref='componentSub' :data='site[index-1]' :lineSize='formParams.json._lineSize' :checkSize='formParams.json._checkSize' :formId='formParams.formId' :formPattern='formPattern'></ParseJson>
            </td>
          </tr>
        </template>
      </table>
      <template v-for="hid in formParams.json._jsonHide">
        <input type="hidden" :name='hid.name' :value='hid.value' ref='hiddenEle'/>
      </template>
      </form>
      <!--<button @click='validateResult'>Validate(测试表单验证)</button>-->
      <!--<button @click='getDatas'>GetDatas(测试返回数据)</button>-->
      <!--<button @click='reMount'>ReMount(重新渲染)</button>-->
    </div>
</template>

<script>
import ParseJson from './parseJson';

export default {
  /**
   * 入参: json {
   *        _jsonShow: 需要显示的字段
   *        _jsonHide: 需要隐藏的字段
   *        _lineSize: 单行容量
   *        __checkSize: checkbox单行容量,未设置默认为3 （目前只支持3/4两种容量）
   *      }
   * method: {
   *   getDatas() 以map形式返回当前组件所有字段属性值
   * }
   */
  name: 'ParseForm',
  components: {
    ParseJson
  },
  data() {
    return {
      param: {},
      hackReset: true
    };
  },
  props: [
    'formParams',
    'reMountPage',
    'formPattern'
  ],
  methods: {
    /** 赋值函数 */
    setData(key, value) {
      setTimeout(() => {
        for (const sub of this.$refs.componentSub) {
          if (sub.getName() === key) {
            sub.setData(value);
          }
        }
      }, 0);
    },

    /** 获值函数 */
    getDatas() {
      const params = new Map();
      if (this.$refs.hiddenEle !== undefined) {
        for (const hid of this.$refs.hiddenEle) {
          if (hid !== undefined && hid.name !== '') {
            params.set(hid.name, hid.value);
          }
        }
      }
      if (this.$refs.componentSub !== undefined) {
        for (const sub of this.$refs.componentSub) {
          const reData = sub.getData();
          if (reData !== undefined && reData.name !== '') params.set(reData.name, reData.paramVal === undefined ? '' : reData.paramVal);
        }
      }
      return params;
    },

    setSelectOptions(name, options) {
      setTimeout(() => {
        for (const sub of this.$refs.componentSub) {
          if (sub.getName() === name) {
            sub.setSelectOptions(options)
          }
        };
      }, 0)
    },

    /** 表单验证 */
    validateResult() {
      for (const sub of this.$refs.componentSub) { // 返回所有子组件是否验证通过
        if (sub.validateComponent() === false) return false;
      }
      return true;
    },

    /** 重新渲染 */
    reMount(data = null) {
      this.formParams.subObject.setDatas(data === null ? this.getDatas() : data);
      this.formParams.json = this.formParams.subObject.reLoad().get(this.formParams.modelName) === undefined ? [] : this.formParams.subObject.reLoad().get(this.formParams.modelName);
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    },

    bindClickFunc(key, func) {
      setTimeout(() => {
        for (const sub of this.$refs.componentSub) {
          if (sub.getName() === key) {
            sub.bindClickFunc(func);
          }
        }
      }, 0);
    },

    $childSelectChange(attr) {
      if (attr === undefined) return;
      this.formParams.subObject.$templetCover(attr);
      this.reMountPage === undefined ? this.reMount() : this.reMountPage();
    },

  },
};
</script>

<style scoped>

</style>
